import { useState } from 'react'
import icon from '../../../../img/border.png'
import { ColorPicker } from '../ColorPicker/ColorPicker'
import './border-options.css'
export function BorderPopup(props) {
    const borderWidth =['None', '1','2','3','4','5']
    const onHandlerUpdateColor = (color) => {
        props.updateChoosedOptions({borderColor: color})
    }
    return (
        <div className="option-popup__wrapper">
            <div className="option-popup__close" onClick={() => props.closePopup(null)}></div>
            <div className="option-popup__title flex items-center">
                <figure className="option-popup__icon">
                    <img src={icon} alt='size icon' />
                </figure>
                <h4>Border Style</h4>
            </div>
            <p>
                Select your border style from the options below
            </p>
                <div className='border-options'>
                    <p><strong>Border Width</strong></p>
                    <div className='border-options__options-width flex flex-wrap'>
                        {borderWidth.map((item) => {
                            if (item === 'None') {
                                return <div className={item === props.choosedOptions.borderWidth ? 'border-options__width--active border-options__width flex flex-col  items-center' : ' border-options__width flex flex-col  items-center'} onClick={() => props.updateChoosedOptions({borderWidth: item})}>{item}</div>
                            }
                            return <div className={item === props.choosedOptions.borderWidth ? 'border-options__width--active border-options__width flex flex-col  items-center' : ' border-options__width flex flex-col  items-center'} onClick={() => props.updateChoosedOptions({borderWidth: item})}>
                                <span className='border-options__border' style={{'height': item + 'px'}}></span>{item}
                                </div>
                        })}
                    </div>
                    <p><strong>Border Colour</strong></p>
                    <ColorPicker color={props.choosedOptions.borderColor} updateColor={onHandlerUpdateColor}></ColorPicker>
                </div>
            <div className="option-popup__btn flex justify-center"><div className="btn" onClick={() => props.closePopup(null)}>CONTINUE</div></div>

        </div>
    )
}